import axios from '../utils/requestVenue';

export const uploadImage = data => axios.post('/upload', data);

// 核销

export const getWeixinSdkParams = () => axios.get('/sdk');

export const getLogin = () => axios.get('/check');

export const createCheck = ({ code }) => axios.post('/check', { codeNo: code });

// 选座

export const getTickets = () => axios.get('/tickets');

export const getTicketDetail = id => axios.get(`/ticket/${id}`);

export const getTicketDetailSeats = (id, date) =>
  axios.get(`/seats/${id}`, { params: { use_date: date } });

export const getOrders = params => axios.get('/codes', { params });

export const createOrder = data => axios.post('/ticket_pay', data);

export const refundOrder = data => axios.post('/refund', data);

export const getUserDetail = () => axios.get('/user');

export const updateUserInfo = data => axios.post('/user_update', data);

export const getMemberSet = () => axios.get('/memberset');

export const getMemberRebate = params => axios.get('/distribution_fl_list', { params });

export const getMemberExtract = params => axios.get('/distribution_tx_list', { params });

export const getMemberExtractMoney = () => axios.get('/distribution_tx_edit');

export const postMemberExtractMoney = ({ time } = {}) => axios.post('/distribution_tx', { time });

export const getMemberSubordinate = params => axios.get('/distribution_member_sub', { params });

export const getMemberPayCode = () => axios.get('/member_pay_code');

export const getMemberChargeProjects = params => axios.get('/member_charge', { params });

export const getMemberChargePay = data => axios.post('/member_pay', data);

export const getMemberChargeOrders = () => axios.get('/member_order_list');
